export const INVESTMENT_TYPE_OPTION_GROUPS = [
  {
    label: "Required",
    options: [
      "Equity investments",
      "Debt investments (with known use of proceeds)",
      "Project finance",
    ],
  },
  {
    label: "Optional",
    options: [
      "Managed investments and client services",
      "Other investments or financial services",
    ],
  },
];

export const INVESTMENT_TYPE_OPTIONS = INVESTMENT_TYPE_OPTION_GROUPS.flatMap(
  (group) => group.options
);

export const PROJECT_FINANCE_INVESTMENT_TYPE = "Project finance";

export const DEBT_WITH_KNOWN_USE_INVESTMENT_TYPE =
  "Debt investments (with known use of proceeds)";

export const usesProjectFinanceFieldLabels = (investmentType) => {
  const type = String(investmentType || "").trim();
  return (
    type === PROJECT_FINANCE_INVESTMENT_TYPE ||
    type === DEBT_WITH_KNOWN_USE_INVESTMENT_TYPE
  );
};

const PROJECT_STYLE_FIELD_LABELS = {
  equityHoldingPercent: "Financial Share (%)",
  scope1EmissionsMetricTon: "Project scope 1 Emissions (tCO2e)",
  scope2EmissionsMetricTon: "Project scope 2 Emissions (tCO2e)",
  scope3EmissionsMetricTon: "Project scope 3 Emissions (tCO2e)",
};

const DEFAULT_FIELD_LABELS = {
  equityHoldingPercent: "Allocation Share (%)",
  scope1EmissionsMetricTon: "Scope 1 Emissions (tCO2e)",
  scope2EmissionsMetricTon: "Scope 2 Emissions (tCO2e)",
  scope3EmissionsMetricTon: "Scope 3 Emissions (tCO2e)",
};

export const getInvestmentFieldLabel = (fieldName, investmentType) => {
  const labels = usesProjectFinanceFieldLabels(investmentType)
    ? PROJECT_STYLE_FIELD_LABELS
    : DEFAULT_FIELD_LABELS;
  return labels[fieldName] || null;
};

const OPTIONAL_INVESTMENT_TYPES = new Set(
  INVESTMENT_TYPE_OPTION_GROUPS.find((group) => group.label === "Optional")
    ?.options || []
);

/** Scope 1 & 2 are required for "Required" investment types; optional for "Optional" types. */
export const isScope12RequiredForInvestmentType = (investmentType) => {
  const type = String(investmentType || "").trim();
  if (!type) return true;
  return !OPTIONAL_INVESTMENT_TYPES.has(type);
};

export const isProjectFinanceInvestmentType = (investmentType) =>
  String(investmentType || "").trim() === PROJECT_FINANCE_INVESTMENT_TYPE;
